var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63128 4.63128C4.97299 4.28957 5.52701 4.28957 5.86872 4.63128L16.3687 15.1313C16.7104 15.473 16.7104 16.027 16.3687 16.3687C16.027 16.7104 15.473 16.7104 15.1313 16.3687L4.63128 5.86872C4.28957 5.52701 4.28957 4.97299 4.63128 4.63128Z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3687 4.63128C16.027 4.28957 15.473 4.28957 15.1313 4.63128L4.63128 15.1313C4.28957 15.473 4.28957 16.027 4.63128 16.3687C4.97299 16.7104 5.52701 16.7104 5.86872 16.3687L16.3687 5.86872C16.7104 5.52701 16.7104 4.97299 16.3687 4.63128Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconClose);
export default __webpack_public_path__ + "static/media/modal-icon-close.f558a17ac0e96d26fb105efdf953ccd5.svg";
export { ForwardRef as ReactComponent };